import { stringify, parse } from 'zipson';

export const compress = (data: any)  => stringify(data);
export const decompress = (data: any) => parse(data);
